import { Button } from '@latitude/button';
import { Text } from '@latitude/text';
import React from 'react';

type FlagActionsProps = {
  flagKey: string;
  isOverridden: boolean;
  hasUnsavedChanges: boolean;
  formattedDefaultValue: string;
  onReset: (key: string) => void;
  onSave: (key: string) => void;
};

export const FlagActions: React.FC<FlagActionsProps> = ({
  flagKey,
  isOverridden,
  hasUnsavedChanges,
  formattedDefaultValue,
  onReset,
  onSave,
}) => {
  return (
    <>
      {isOverridden && (
        <Text variant="captionRegular" color="muted">
          Default: {formattedDefaultValue}
        </Text>
      )}
      <div className="flex gap-2">
        <Button
          onClick={() => onReset(flagKey)}
          variant="neutral"
          size="small"
          disabled={!isOverridden && !hasUnsavedChanges}
        >
          Reset
        </Button>
        <Button
          onClick={() => onSave(flagKey)}
          variant="primary"
          size="small"
          disabled={!hasUnsavedChanges}
        >
          Save
        </Button>
      </div>
    </>
  );
};
